import {
  addScheduleInterview,
  getScheduledInterview,
  getVcclData,
  cancelVccl,
  removeGmeet,
  reScheduleGmeet,
  scheduleGmeet,
  getTeamsToken,
  getPanelPagination,
  getActivePanelist,
  getHire3xPanelCount,
  selectPanelSlot,
  cancelmeeting,
  getSelectedPanelSlot,
  removeSelectedPanelSlot,
  // removeSelectedPanelSlot
} from "../../../utils/apiFunctions";
import { mapGetters } from "vuex";
import axios from "axios";
const scheduleMixin = {
  name: "scheduleMixin",
  data() {
    return {
      meetStatus: null,
      type: null,
      checkLicense: true,
      staticLicenseKey: [
        "L082623A002",
        "L041025A002",
        "L090924A001",
        "L052922A001",
        "L071122A001",
        "L041626A001",
      ],
      interviewRequestID: null,
      login_type: 1,
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      googleCredentials: "getCredentials",
      licenseKey: "getlicenseKey",
    }),
    checkTeamsLogin() {
      if (this.showCheckAvailability) {
        return localStorage.getItem("teamsAccessToken");
      } else {
        return true;
      }
    },
    showCheckAvailability() {
      return this.login_type == 2;
    },
    getPlatform() {
      let platform;
      if (this.ScheduleInterview.selectedOption == "Microsoft Teams")
        platform = "teams";
      else platform = "vccl";
      return platform;
    },
  },
  methods: {
    async removeSelectedPanelSlot() {
      try {
        const res = await removeSelectedPanelSlot({
          interviewRequestID: this.interviewRequestID,
        });
        if (res.status == 200) {
          if (this.type == "cancel") {
            this.successModal("Meeting Cancelled");
            this.LoaderStatus = false;
            this.$emit("cancel-success");
            this.closeCancelModal();
          }
          return true;
        } else {
          this.failurePopup();
          return false;
        }
      } catch (error) {
        console.error(error);
        this.failurePopup();
        return false;
      }
    },
    async getSelectedPanelSlot() {
      try {
        const res = await getSelectedPanelSlot({
          emailID: this.candidate.email,
          jobID: this.particularJob.jobID,
        });
        if (res.status == 200) {
          const { allowBot, date, startTime, endTime, platform } =
            res.data.data;
          this.ScheduleInterview = {
            ...this.ScheduleInterview,
            allowBot,
            selDate: date,
            startTime,
            endTime,
            selectedOption:
              platform === "vccl" ? "Hire3x - VCCL" : "Microsoft Teams",
          };
          this.interviewRequestID = res.data.data.interviewRequestID;
          this.ScheduleInterview.selDate = this.getDateInFormat();
          if (res.data.data.interviewScheduleType == 2) {
            this.showhire3xPanelContent = true;
            this.getHire3xPanelCount();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async cancelMeeting() {
      try {
        let payload = {
          candidateID: this.candidate.candidateID,
          jobID: this.particularJob.jobID,
          customerID: this.particularJob.customerID,
          remarks: "",
        };
        const res = await cancelmeeting(payload);
        if (res.status != 200) {
          this.LoaderStatus = false;
          this.errorModal("Something went wrong");
        }
      } catch (err) {
        console.log(err);
        this.LoaderStatus = false;
        this.errorModal("Something went wrong");
      }
    },
    convertDateTimeToUTC(dateStr, timeStr) {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Split dd-mm-yyyy → yyyy-mm-dd for JS compatibility
      const [day, month, year] = dateStr.split("-");
      const formattedDate = `${year}-${month}-${day}T${timeStr}:00`;

      // Create a date that represents that local time in the given timezone
      const dateInTimeZone = new Date(
        new Date(formattedDate).toLocaleString("en-US", { timeZone })
      );

      // Return UTC in ISO format
      return dateInTimeZone.toISOString();
    },
    async getHire3xPanelCount() {
      this.panelLoading = true;
      try {
        const res = await getHire3xPanelCount({
          skills: this.particularJob.skills,
        });
        if (res.status == 200) {
          this.hire3xPanelCount = res.data.data.availablePanelCount;
        } else {
          this.dynamicToast("Error", "Something went wrong!");
        }
      } catch (error) {
        console.error(error);
        this.dynamicToast("Error", "Something went wrong!");
      } finally {
        this.panelLoading = false;
      }
    },
    capitalize(text) {
      return text
        .split(" ")
        .filter((word) => word.trim() !== "")
        .map((word) => word[0].toUpperCase() + word.slice(1))
        .join(" ");
    },
    getDurationInMinutes(startTime, endTime) {
      const start = new Date(startTime);
      const end = new Date(endTime);

      const diffMs = end - start;

      if (isNaN(diffMs) || diffMs < 0) return 0;

      const totalMinutes = Math.floor(diffMs / 60000);
      return totalMinutes;
    },
    onScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        // Check if there is more data to load.
        if (
          this.checkbetween(this.pageEnd, 0, this.total) &&
          !this.showLoader
        ) {
          this.currentPage++;
          this.showLoader = true;
          this.getPanelPagination();
        }
      }
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    closeSearch() {
      this.showsearchDropdown = false;
    },
    removePanel(panel) {
      if (panel.panelID) {
        this.totalPanel = this.totalPanel.filter(
          (obj) => obj.panelID != panel.panelID
        );
        this.removeIntPanel(panel.panelID);
      } else {
        this.totalPanel = this.totalPanel.filter(
          (obj) => obj.name != panel.name
        );
        let index = this.ScheduleInterview.externalPanelist.indexOf(panel.name);
        this.removeExtPanel(index);
      }
    },
    filterPanelData() {
      const idsInArray2 = new Set(
        this.ScheduleInterview.panelist.map((item) => item.panelID)
      );
      this.panelDetails = this.panelDetails.filter(
        (item) => !idsInArray2.has(item.panelID)
      );
      this.$forceUpdate();
    },
    addPanel(panel) {
      if (typeof panel == "string") {
        this.ScheduleInterview.externalPanelist.push(panel);
        this.totalPanel.push({ name: panel });
      } else if (Array.isArray(panel)) {
        this.ScheduleInterview.panelist = panel;
        this.totalPanel = this.totalPanel.filter((item) => {
          return !item.panelID || panel.some((p) => p.panelID === item.panelID);
        });
        panel.forEach((obj) => {
          const exists = this.totalPanel.find(
            (item) => item.panelID === obj.panelID
          );
          if (!exists) {
            this.totalPanel.push({ name: obj.name, panelID: obj.panelID });
          }
        });
        // panel.map((obj) => {
        //   this.totalPanel.push({ name: obj.name, panelID: obj.panelID });
        // });
      } else {
        this.ScheduleInterview.panelist.push(panel);
        this.totalPanel.push({ name: panel.name, panelID: panel.panelID });
      }
      this.totalPanel.sort((a, b) => {
        if (a.panelID && !b.panelID) return -1;
        if (!a.panelID && b.panelID) return 1;
        return 0;
      });
      this.extEmail = "";
      this.showsearchDropdown = false;
      this.$forceUpdate();
    },
    searchObjectsByKeyValue() {
      const lowerCaseValue = this.extEmail.toLowerCase();
      this.panelDetails = this.fullData.filter(
        (item) =>
          item.name &&
          item.name.toString().toLowerCase().includes(lowerCaseValue)
      );
      if (this.panelDetails.length == 0 && !this.extEmail) {
        this.panelDetails = this.fullData;
      }
      this.filterPanelData();
    },
    async searchPanelist() {
      if (this.panelList.length == 0) {
        setTimeout(async () => {
          await this.getPanelPagination();
        }, 600);
      } else {
        this.searchObjectsByKeyValue();
      }
    },
    async getPanelPagination() {
      try {
        let payload = {
          type: "1",
          // count: this.pageCount,
          // page: this.currentPage - 1,
          searchQuery: this.extEmail,
        };
        const res = await getPanelPagination(payload);
        if (res.status == 200) {
          if (this.currentPage == 1) {
            this.panelDetails = res.data.data.data;
          } else {
            this.panelDetails = [...this.panelDetails, ...res.data.data.data];
          }
          this.filterPanelData();
          this.pageStart = res.data.data.pageStart;
          this.pageEnd = res.data.data.pageEnd;
          this.total = res.data.data.total;
          this.showLoader = false;
          // this.checkSelectAll();
        }
        // else {
        //   this.LoaderStatus = false;
        // }
      } catch (err) {
        console.error(err);
        // this.LoaderStatus = false;
        // this.errorModal("Something went wrong");
        throw err;
      }
    },
    async getActivePanel() {
      try {
        // this.LoaderStatus = true;
        let panelUserIDs = this.panelDetails.map((obj) => obj.userID);

        let payload = {
          panelUserIDs: panelUserIDs,
        };
        const res = await getActivePanelist(payload);
        if (res.status == 200) {
          // this.LoaderStatus = false;
          this.panelDetails = res.data.data.Details;
          this.panelDetails.forEach((obj) => {
            obj.view = false;
          });
          this.fullPanelData = this.panelDetails;
          this.filterPanelData();
          this.fullData = this.panelDetails;
          // this.checkSelectAll();
        }
        //  else {
        //   this.LoaderStatus = false;
        // }
      } catch (err) {
        console.error(err);
        // this.LoaderStatus = false;
        // this.errorModal("Something went wrong");
        throw err;
      }
    },
    handleSelOptionSwitch() {
      if (this.showCheckAvailability) {
        if (this.ScheduleInterview.selectedOption != "Microsoft Teams") {
          this.ScheduleInterview.panelist.map((obj) => {
            if (obj.panelistStatus) {
              return delete obj.panelistStatus;
            }
          });
          this.totalPanel.map((obj) => {
            if (obj.panelStatus) {
              return delete obj.panelStatus;
            }
          });
        }
      } else {
        if (this.ScheduleInterview.selectedOption == "Microsoft Teams") {
          this.getTeamsAvailability();
        } else {
          this.ScheduleInterview.panelist.map((obj) => {
            return delete obj.panelistStatus;
          });
          this.totalPanel.map((obj) => {
            if (obj.panelStatus) {
              return delete obj.panelStatus;
            }
          });
        }
      }
    },
    async checkAndRemoveGmeet() {
      if (!localStorage.getItem("googleToken")) {
        await this.loadGapiScript();
      } else {
        await this.deleteInterview();
      }
    },
    async checkAndRemoveTeams() {
      if (
        !localStorage.getItem("teamsAccessToken") &&
        this.showCheckAvailability
      ) {
        await this.loginToTeams();
      }
      await this.removeTeamsMeeting();
    },
    async checkAndScheduleGmeet() {
      if (!localStorage.getItem("googleToken")) {
        await this.loadGapiScript();
      } else {
        await this.schedule();
      }
    },
    async checkAndRemove() {
      if (this.initialType == "Hire3x - VCCL") {
        await this.removeVcclMeeting();
      } else if (this.initialType == "Microsoft Teams") {
        await this.checkAndRemoveTeams();
      }
    },
    failurePopup(message) {
      this.LoaderStatus = false;
      let text =
        message == "Login"
          ? `${message} failed, try again!`
          : message
          ? message
          : this.type == "schedule"
          ? "Reschedule meeting failed, try again!"
          : "Cancel meeting failed, try again!";
      this.errorModal(text);
    },
    chekStartTimeInvalid() {
      const now = new Date();
      const sel = new Date(this.getDateInFormat());
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      let currentTime = `${hours}:${minutes}`;
      sel.setHours(0, 0, 0, 0);
      now.setHours(0, 0, 0, 0);
      if (now.getTime() === sel.getTime()) {
        if (this.ScheduleInterview.startTime <= currentTime) {
          this.inValidStartTime = true;
        } else {
          this.inValidStartTime = false;
        }
      } else {
        this.inValidStartTime = false;
      }
    },
    formattedTime() {
      let totalMinutes =
        parseInt(this.ScheduleInterview.startTime.split(":")[0]) * 60 +
        parseInt(this.ScheduleInterview.startTime.split(":")[1]) +
        30;
      let updatedHours = Math.floor(totalMinutes / 60) % 24;
      let updatedMinutes = totalMinutes % 60;
      const formattedHours = String(updatedHours).padStart(2, "0");
      const formattedMinutes = String(updatedMinutes).padStart(2, "0");
      return `${formattedHours}:${formattedMinutes}`;
    },
    timeDifference(date1String, date2String) {
      const date1 = new Date(date1String);
      const date2 = new Date(date2String);
      const diffInMs = Math.abs(date2 - date1);
      let hours = Math.floor(diffInMs / 3600000);
      let minutes = Math.floor((diffInMs % 3600000) / 60000);
      hours *= 60;
      minutes += hours;
      return minutes.toString();
    },
    hideAttendees() {
      return JSON.parse(!this.checkExternalMails);
    },
    companyMail(mail) {
      return (
        mail === "elevancehealth.com" ||
        mail === "legato.com" ||
        mail === "anthem.com" ||
        mail === "carelon.com"
      );
    },
    async getTeamsAvailability() {
      let token;
      let emails;
      if (this.login_type == 1) {
        let payload = {
          company: this.roleValues.email.endsWith("@hire3x.com")
            ? "hire3x"
            : this.roleValues.email.endsWith("@simplify3x.com")
            ? "simplify"
            : this.roleValues.email.endsWith("@norwintechnologies.com")
            ? "norwintechnologies"
            : null,
        };
        const response = await getTeamsToken(payload);
        token = response.data.token;
        emails = this.roleValues.email;
      } else {
        if (!localStorage.getItem("teamsAccessToken")) {
          await this.loginToTeams();
        }
        token = localStorage.getItem("teamsAccessToken");
        emails = JSON.parse(sessionStorage.getItem("account")).idTokenClaims
          .email;
      }
      let paneldata = this.ScheduleInterview.panelist.map((obj) => {
        return obj.email;
      });
      axios({
        method: "POST",
        url: `https://graph.microsoft.com/v1.0/users/${emails}/calendar/getschedule`,
        data: JSON.stringify({
          Schedules: paneldata,
          StartTime: {
            dateTime: this.newDataeVAS,
            timeZone: "UTC",
          },
          EndTime: {
            dateTime: this.newDataeEnd,
            timeZone: "UTC",
          },
          availabilityViewInterval: this.timeDifference(
            this.newDataeEnd,
            this.newDataeVAS
          ),
        }),
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          console.log(this.ScheduleInterview.panelist);
          for (let i in response.data.value) {
            if (response.data.value[i].availabilityView) {
              this.ScheduleInterview.panelist.map((obj) => {
                if (obj.email == response.data.value[i].scheduleId) {
                  if (response.data.value[i].availabilityView == "0") {
                    return (obj.panelistStatus = "Available");
                  } else if (response.data.value[i].availabilityView == "1") {
                    return (obj.panelistStatus = "Tentative");
                  } else if (response.data.value[i].availabilityView == "2") {
                    return (obj.panelistStatus = "Busy");
                  } else if (response.data.value[i].availabilityView == "3") {
                    return (obj.panelistStatus = "Out of office");
                  } else if (response.data.value[i].availabilityView == "4") {
                    return (obj.panelistStatus = "Unavailable");
                  }
                }
              });
            } else {
              this.ScheduleInterview.panelist.map((obj) => {
                if (obj.email == response.data.value[i].scheduleId) {
                  return (obj.panelistStatus = "Out of Organisation");
                }
              });
            }
          }
          const statusMap = this.ScheduleInterview.panelist.reduce(
            (map, obj) => {
              map[obj.panelID] = obj.panelistStatus;
              return map;
            },
            {}
          );

          this.totalPanel = this.totalPanel.map((panel) => ({
            ...panel,
            panelStatus: statusMap[panel.panelID] || null,
          }));
          this.$forceUpdate();
        })
        .catch((error) => {
          console.error(error);
          this.ScheduleInterview.panelistStatus = "Status unknown";
          this.ScheduleInterview.teamsStatus = "6";
        });
    },
    assignLink(type) {
      this.ScheduleInterview.selectedOption = type;
      this.ScheduleInterview.teams = type == "Microsoft Teams" ? true : false;
      this.showmeetingoptions = false;
    },
    hideMeeting() {
      this.showmeetingoptions = false;
    },
    getFormattedTime(time) {
      const date = new Date(time);
      if (!isNaN(date.getTime())) {
        // Extract hours and minutes
        const hours = date.getUTCHours().toString().padStart(2, "0");
        const minutes = date.getUTCMinutes().toString().padStart(2, "0");
        // Format the extracted time as HH:MM
        return `${hours}:${minutes}`;
      }
      // return `${this.ScheduleInterview.date}T${time}:00.000+00:00`;
    },
    getFormattedDate(date) {
      return `${date}T00:00:00.000+00:00`;
    },
    getVcclAttendees() {
      let attend = [];
      // ADDING RECRUITER EMAIL
      if (!this.showbotinterviewContent) attend.push(this.roleValues.email);
      // ADDING CANDIDATE EMAIL
      attend.push(this.candidate.email);

      // ADDING PANELIST EMAIL
      if (this.ScheduleInterview.panelist.length != 0) {
        let val = this.ScheduleInterview.panelist.map((obj) => {
          return obj.email;
        });
        for (const i of val) {
          attend.push(i);
        }
      }
      if (this.ScheduleInterview.externalPanelist.length != 0) {
        for (const i of this.ScheduleInterview.externalPanelist) {
          attend.push(i);
        }
      }
      return attend;
    },
    getGmeetAttendees() {
      let values = this.getAttendees().map((data) => {
        return data.emailAddress.address;
      });
      return values;
    },
    getAttendees() {
      let attend = [];
      // ADDING CANDIDATE EMAIL

      attend.push({
        emailAddress: {
          address: this.candidate.email,
        },
        type: "required",
      });
      // ADDING PANELIST EMAIL
      if (this.ScheduleInterview.externalPanelist.length != 0) {
        for (const i of this.ScheduleInterview.externalPanelist) {
          attend.push({
            emailAddress: {
              address: i,
            },
            type: "required",
          });
        }
      }
      if (this.ScheduleInterview.panelist.length != 0) {
        for (const i of this.ScheduleInterview.panelist) {
          attend.push({
            emailAddress: {
              address: i.email,
            },
            type: "required",
          });
        }
      }
      return attend;
    },
    async checkSchedule() {
      this.$v.ScheduleInterview.$touch();
      if (this.$v.ScheduleInterview.$invalid) {
        this.errorModal("Please enter all fields!");
      } else if (
        this.inValidStartTime ||
        this.inValidEndTime ||
        this.isStartDateValid
      ) {
        this.errorModal("Please select valid date and time!");
      } else if (
        ((this.showhire3xPanelContent && this.hire3xPanelCount == 0) ||
          !this.showhire3xPanelContent) &&
        !this.showbotinterviewContent &&
        !this.inValidStartTime &&
        !this.inValidEndTime &&
        !this.$v.ScheduleInterview.$invalid &&
        this.ScheduleInterview.externalPanelist.length == 0 &&
        this.ScheduleInterview.panelist.length == 0
      ) {
        this.panelError = true;
        this.errorModal(this.panelErrorText);
      } else if (
        !this.inValidStartTime &&
        !this.inValidEndTime &&
        !this.$v.ScheduleInterview.$invalid &&
        !this.isStartDateValid
      ) {
        if (
          this.ScheduleInterview.selectedOption === "Hire3x - VCCL" &&
          !this.vendor &&
          this.getPanelistCount() > 3
        ) {
          this.errorModal(
            "Cannot schedule VCCL meeting with more than 3 panelists!"
          );
        }
        // else if (
        //   this.showbotinterviewContent &&
        //   !this.vendor &&
        //   this.getPanelistCount() > 2
        // ) {
        //   this.errorModal(
        //     "Cannot schedule Bot interview with more than 2 panelists!"
        //   );
        // }
        else {
          if (this.showbotinterviewContent || this.showhire3xPanelContent) {
            this.ScheduleInterview.externalPanelist = [];
            this.ScheduleInterview.panelist = [];
          }
          this.LoaderStatus = true;
          this.assignLink(this.ScheduleInterview.selectedOption);
          if (!this.showhire3xPanelContent && this.interviewRequestID) {
            const removed = await this.removeSelectedPanelSlot();
            if (!removed) {
              this.LoaderStatus = false;
              return;
            }
          }
          if (this.showhire3xPanelContent) await this.checkAndSelectSlot();
          else await this.checkLoginAndProceed();
        }
      }
    },
    async checkAndSelectSlot() {
      if (this.initialType) {
        if (this.initialType == "Google Meet") await this.checkAndRemoveGmeet();
        else await this.checkAndRemove();
        // await this.cancelMeeting();
      }
      if (this.LoaderStatus && !this.meetStatus) {
        if (this.initialType) await this.cancelMeeting();
        await this.selectPanelSlot();
      }
    },
    async selectPanelSlot() {
      try {
        let payload = {
          jobID: this.particularJob.jobID,
          customerID: this.particularJob.customerID,
          licenseKey: this.licenseKey,
          email: this.candidate.email,
          slot: this.convertDateTimeToUTC(
            this.ScheduleInterview.selDate,
            this.ScheduleInterview.startTime
          ),
          platform: this.getPlatform,
          startTime: this.ScheduleInterview.startTime,
          endTime: this.ScheduleInterview.endTime,
          date: this.getDateInFormat(),
          allowBot: this.ScheduleInterview.allowBot,
        };
        if (this.fromAction) {
          payload = {
            ...payload,
            currentLevel: this.candidate.kanbanLevel,
            actionLevel: parseInt(this.toRound),
          };
        }
        const res = await selectPanelSlot(payload);
        if (res.status == 200) {
          this.closeScheduleInterview();
          this.$emit("schedule-success");
          this.$nextTick(() => {
            this.dynamicToast(
              "success",
              `Successfully selected`,
              "Interview slot selected successfully"
            );
          });
        } else {
          this.dynamicToast("Error", "Something went wrong!");
        }
      } catch (error) {
        console.log(error);
        this.dynamicToast("Error", "Something went wrong!");
      } finally {
        this.LoaderStatus = false;
      }
    },
    async checkLoginAndProceed() {
      console.log("in hererrerrerre");
      if (!this.vendor) {
        let selectedOption = JSON.parse(
          JSON.stringify(this.ScheduleInterview.selectedOption)
        );
        if (selectedOption == "Google Meet") {
          if (this.initialType == selectedOption || !this.initialType) {
            if (!localStorage.getItem("googleToken")) {
              await this.loadGapiScript();
            } else {
              this.initialType
                ? await this.updateInterview()
                : await this.schedule();
            }
          } else if (this.initialType && this.initialType != selectedOption) {
            if (
              this.initialType == "Microsoft Teams" &&
              localStorage.getItem("googleToken") &&
              this.checkTeamsLogin
            ) {
              await this.checkAndRemove();
              await this.schedule();
            } else if (this.initialType == "Microsoft Teams") {
              if (this.showCheckAvailability) await this.loginToTeams();
              if (this.LoaderStatus) {
                await this.loadGapiScript();
              }
            } else if (
              this.initialType == "Hire3x - VCCL" ||
              this.initialType == "Other"
            ) {
              await this.checkAndScheduleGmeet();
              if (!this.meetStatus && this.initialType == "Hire3x - VCCL") {
                await this.removeVcclMeeting();
              }
            }
          }
        } else if (selectedOption == "Microsoft Teams") {
          if (this.initialType == selectedOption || !this.initialType) {
            if (
              !localStorage.getItem("teamsAccessToken") &&
              this.showCheckAvailability
            ) {
              await this.loginToTeams();
            }
            this.initialType && this.showCheckAvailability
              ? await this.rescheduleTeamsMeeting()
              : this.initialType && !this.showCheckAvailability
              ? (this.removeTeamsMeeting(), await this.createTeamsmeeting())
              : await this.createTeamsmeeting();
          } else if (this.initialType && this.initialType != selectedOption) {
            if (
              this.initialType == "Google Meet" &&
              localStorage.getItem("googleToken") &&
              this.checkTeamsLogin
            ) {
              await this.deleteInterview();
              await this.createTeamsmeeting();
            } else if (this.initialType == "Google Meet") {
              if (this.showCheckAvailability) await this.loginToTeams();
              if (this.LoaderStatus) {
                await this.loadGapiScript();
              }
            } else if (
              this.initialType == "Hire3x - VCCL" ||
              this.initialType == "Other"
            ) {
              if (
                !localStorage.getItem("teamsAccessToken") &&
                this.showCheckAvailability
              ) {
                await this.loginToTeams();
              }
              await this.createTeamsmeeting();
              if (this.initialType == "Hire3x - VCCL") {
                await this.removeVcclMeeting();
              }
            }
          }
        } else if (selectedOption == "Hire3x - VCCL") {
          if (this.initialType == selectedOption) {
            await this.removeVcclMeeting();
            await this.createVcclMeeting();
          } else if (this.initialType != selectedOption) {
            if (this.initialType == "Microsoft Teams") {
              await this.checkAndRemoveTeams();
            } else if (this.initialType == "Google Meet") {
              await this.checkAndRemoveGmeet();
            }
            if (this.LoaderStatus) {
              await this.createVcclMeeting();
            }
          }
        } else if (
          selectedOption == "Other" &&
          this.initialType != selectedOption
        ) {
          if (this.initialType == "Microsoft Teams") {
            await this.checkAndRemoveTeams();
          } else if (this.initialType == "Google Meet") {
            await this.checkAndRemoveGmeet();
          } else if (this.initialType == "Hire3x - VCCL") {
            await this.removeVcclMeeting();
          }
        }
      }
      if (
        (this.LoaderStatus && !this.meetStatus) ||
        (this.vendor && this.LoaderStatus)
      ) {
        await this.scheduleInterview();
      }
    },
    async removeVcclMeeting() {
      let payload = {
        roomId:
          this.type == "schedule"
            ? this.interviewRound.interviewRound.roomId
            : this.ScheduleInterview.interviewRound.roomId,
      };
      try {
        const res = await cancelVccl(payload);
        if (res.status !== 200) {
          this.failurePopup();
          if (this.type == "cancel") this.closeCancelModal();
        }
      } catch (error) {
        this.failurePopup();
        if (this.type == "cancel") this.closeCancelModal();
        throw error;
      }
    },
    async createVcclMeeting() {
      let payload = {
        title: `Simplify3x Interview - ${this.particularJob.title} - ${this.candidate.name} - ${this.ScheduleInterview.startTime}`,
        Attendees: this.getVcclAttendees(),
        startime: this.newDataeVAS,
        endime: this.newDataeEnd,
        description: this.ScheduleInterview.meetingSummary,
        MeetingTimeZone: "(UTC+05:30) Asia/Calcutta",
        type: "schedule",
        source: "RECRUITMENT",
      };
      if (this.showbotinterviewContent) {
        let jobRole =
          this.particularJob.role == "others"
            ? this.particularJob.otherRole
            : this.particularJob.role;
        let formattedSkills = this.particularJob.skills.map((obj) => {
          return this.capitalize(obj);
        });
        let newData = {
          role: this.capitalize(jobRole),
          skills: formattedSkills.join(", "),
          company: this.particularJob.licenseOrganization,
          experienceYears: !this.particularJob.customFields?.experienceRequired
            ? "0"
            : this.particularJob.customFields?.experienceRequired,
          duration: this.getDurationInMinutes(
            this.newDataeVAS,
            this.newDataeEnd
          ),
          interviewType: "Technical",
          candidateID: this.candidate.candidateID,
          jobID: this.particularJob.jobID,
        };
        payload.otherInfo = {
          isAiInterview: true,
          interviewDetails: newData,
        };
      }
      const res = await getVcclData(payload);
      this.ScheduleInterview.roomId = res.data.roomId;
      this.ScheduleInterview.meetingLink = res.data.roomLink;
      return res.status;
    },
    async initGapiClient() {
      return new Promise((resolve, reject) => {
        window.gapi.load("auth2", () => {
          window.gapi.auth2
            .init({
              client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
              scope:
                "https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/meetings.space.created",
              plugin_name: "chat",
            })
            .then(async () => {
              await this.handleAuthClick();
              resolve();
            })
            .catch((error) => {
              console.error("Error initializing Google API client:", error);
              this.failurePopup("Login");
              reject();
            });
        });
      });
    },
    async deleteInterview() {
      let eventid =
        this.type == "cancel"
          ? this.ScheduleInterview.interviewRound.eventID
          : this.interviewRound.interviewRound.eventID;
      try {
        let payload = {
          event_id: eventid,
          user_credentials: this.googleCredentials,
          subject: `Invitation from Hire3X`,
          description: "Welcome to the Hire3X !!",
          meetingTitle: `Simplify3x Interview - ${this.particularJob.title}`,
        };
        const res = await removeGmeet(payload);
        if (res.status !== 200) {
          this.failurePopup();
          if (this.type == "cancel") this.closeCancelModal();
        }
      } catch (error) {
        console.error(error);
        this.failurePopup();
        if (this.type == "cancel") this.closeCancelModal();
      }
    },
    async updateInterview() {
      try {
        let payload = {
          event_id: this.interviewRound.interviewRound.eventID,
          user_credentials: this.googleCredentials,
          new_start_date: this.newDataeVAS.split(".000Z")[0],
          new_end_date: this.newDataeEnd.split(".000Z")[0],
          new_subject: "Updated Schedule",
          new_description: "Welcome to the Hire3X !!",
          new_meeting_title: `Simplify3x Interview - ${this.particularJob.title}`,
          attendees: this.getGmeetAttendees(),
        };
        const res = await reScheduleGmeet(payload);
        if (res.status == 200) {
          this.ScheduleInterview.eventID =
            this.interviewRound.interviewRound.eventID;
          this.ScheduleInterview.meetingCode =
            this.interviewRound.interviewRound.meetingCode;
        } else {
          this.failurePopup();
        }
      } catch (error) {
        console.error(error);
        this.failurePopup();
      }
    },
    async schedule() {
      try {
        let payload = {
          startDate: this.newDataeVAS.split(".000Z")[0],
          endDate: this.newDataeEnd.split(".000Z")[0],
          user_credentials: this.googleCredentials,
          attendees: this.getGmeetAttendees(),
          subject: `Invitation from Hire3X`,
          description: "Welcome to the Hire3X !!",
          meetingTitle: `Simplify3x Interview - ${this.particularJob.title} - ${this.candidate.name} - ${this.ScheduleInterview.startTime}`,
        };
        const res = await scheduleGmeet(payload);
        if (res.status == 200) {
          this.ScheduleInterview.meetingLink = res.data.meet_uri;
          this.ScheduleInterview.eventID = res.data.event_id;
          this.ScheduleInterview.meetingCode = res.data.meeting_code;
        } else {
          this.LoaderStatus = false;
          this.errorModal("Create meeting failed, try again!");
        }
      } catch (err) {
        this.LoaderStatus = false;
        this.errorModal("Create meeting failed, try again!");
      }
    },
    async handleAuthClick() {
      try {
        const auth2 = window.gapi.auth2.getAuthInstance();
        if (!auth2) {
          throw new Error("Google Auth instance is not available");
        }

        const googleUser = await auth2.signIn();
        // const profile = googleUser.getBasicProfile();
        const authResponse = googleUser.getAuthResponse();

        localStorage.setItem("googleToken", authResponse.access_token);

        const payload = {
          account: "",
          client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
          client_secret: process.env.VUE_APP_GOOGLE_CLIENT_SECRET,
          expiry: new Date(authResponse.expires_at).toISOString(),
          refresh_token: authResponse.id_token,
          scopes: authResponse.scope
            ? authResponse.scope.split(" ")
            : [
                "https://www.googleapis.com/auth/calendar",
                "https://www.googleapis.com/auth/meetings.space.created",
              ],
          token: authResponse.access_token,
          token_uri: "https://oauth2.googleapis.com/token",
          universe_domain: "googleapis.com",
        };
        this.$store.commit("userVUEX/setCredentials", payload);
        if (this.type == "cancel") {
          await this.deleteInterview();
          if (this.LoaderStatus) {
            await this.cancelMeeting();
          }
        } else {
          if (
            this.initialType &&
            this.initialType != this.ScheduleInterview.selectedOption &&
            this.initialType == "Google Meet"
          ) {
            await this.deleteInterview();
          } else if (
            this.schedulename.split(" ")[0] == "Schedule" ||
            (this.initialType && this.initialType != "Google Meet")
          ) {
            await this.schedule();
          } else {
            await this.updateInterview();
          }
          await this.checkAndRemove();
          if (
            this.LoaderStatus &&
            this.initialType == "Google Meet" &&
            this.ScheduleInterview.selectedOption == "Microsoft Teams"
          ) {
            await this.createTeamsmeeting();
          }
          if (this.LoaderStatus) {
            await this.scheduleInterview();
          }
        }
      } catch (error) {
        this.failurePopup("Login");
        console.error("Error during Google login:", error);
      }
    },
    async removeTeamsMeeting() {
      let token;
      let emails;
      if (this.login_type == 1) {
        let payload = {
          company: this.roleValues.email.endsWith("@hire3x.com")
            ? "hire3x"
            : this.roleValues.email.endsWith("@simplify3x.com")
            ? "simplify"
            : this.roleValues.email.endsWith("@norwintechnologies.com")
            ? "norwintechnologies"
            : null,
        };
        const response = await getTeamsToken(payload);
        token = response.data.token;
        emails = this.roleValues.email;
      } else {
        if (!localStorage.getItem("teamsAccessToken")) {
          await this.loginToTeams();
        }
        token = localStorage.getItem("teamsAccessToken");
        emails = JSON.parse(sessionStorage.getItem("account")).idTokenClaims
          .email;
      }
      let meetingID =
        this.type == "cancel"
          ? this.ScheduleInterview.interviewRound.meetingID
          : this.interviewRound.interviewRound.meetingID;
      return axios({
        method: "delete",
        url: `https://graph.microsoft.com/v1.0/users/${emails}/calendar/events/${meetingID}`,
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          return response.status;
        })
        .catch((error) => {
          this.failurePopup();
          if (this.type == "cancel") this.closeCancelModal();
          throw error;
        });
    },
    async rescheduleTeamsMeeting() {
      const token = localStorage.getItem("teamsAccessToken");
      const account = JSON.parse(sessionStorage.getItem("account"));

      const updatedMeeting = {
        subject: `Simplify3x Interview - ${this.particularJob.title} - ${this.candidate.name} - ${this.ScheduleInterview.startTime}`,
        start: {
          dateTime: this.newDataeVAS,
          timeZone: "UTC",
        },
        end: {
          dateTime: this.newDataeEnd,
          timeZone: "UTC",
        },
        body: {
          contentType: "html",
          content: `<html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8">\r\n<meta name="Generator" content="Microsoft Exchange Server">\r\n<!-- converted from text -->\r\n<style><!-- .EmailQuote { margin-left: 1pt; padding-left: 4pt; border-left: #800000 2px solid; } --></style></head>\r\n<body>\r\n<font size="2"><span style="font-size:11pt;"><div class="PlainText">&nbsp;</div> <div class="PlainText"><h1> Please Join Re-Scheduled Meeting </h1> </div></span></font>\r\n</body>\r\n</html>\r\n`,
        },
        attendees: this.getAttendees(),
        isOnlineMeeting: true,
        onlineMeetingProvider: "teamsForBusiness",
        hideAttendees: this.hideAttendees(),
      };

      try {
        // Get the existing event to preserve meeting blob for online meetings
        const existingEventResponse = await axios.get(
          `https://graph.microsoft.com/v1.0/users/${account.idTokenClaims.email}/calendar/events/${this.interviewRound.interviewRound.meetingID}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // Preserve the meeting blob from the existing event
        updatedMeeting.body = existingEventResponse.data.body;
        // Update the event with the modified properties
        await axios.patch(
          `https://graph.microsoft.com/v1.0/users/${account.idTokenClaims.email}/calendar/events/${this.interviewRound.interviewRound.meetingID}`,
          updatedMeeting,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        this.ScheduleInterview.meetingID =
          this.interviewRound.interviewRound.meetingID;
      } catch (error) {
        // Check if error.response is defined before accessing its properties
        if (error.response && error.response.data) {
          console.error("Error rescheduling meeting:", error.response.data);
        } else {
          console.error("Error rescheduling meeting:", error);
        }
        this.failurePopup();
      }
    },
    async getAccessToken() {
      try {
        const accounts = await this.msalInstance.getAllAccounts();
        if (accounts.length === 0) {
          throw new Error("No accounts logged in.");
        }
        const response = await this.msalInstance.acquireTokenSilent({
          scopes: [
            "User.Read",
            "Calendars.ReadWrite",
            "OnlineMeetings.ReadWrite",
          ],
          account: accounts[0], // Use the first account
        });
        const teamsAccessToken = response.accessToken;
        localStorage.setItem("teamsAccessToken", teamsAccessToken);
        // await this.createTeamsmeeting();
      } catch (error) {
        console.error("Error acquiring access token:", error);

        this.errorModal(
          `${this.schedulename.split(" ")[0]} meeting failed, try again!`
        );
        this.LoaderStatus = false;
        throw error;
      }
    },
    async showMicrosoftLogin() {
      if (!this.msalInstance) {
        console.error("MSAL instance not initialized.");
        return;
      }
      try {
        const loginRequest = {
          scopes: ["openid", "profile", "email"],
        };
        const authResponse = await this.msalInstance.loginPopup(loginRequest);
        const account = authResponse.account;
        sessionStorage.setItem("account", JSON.stringify(account));
        await this.getAccessToken();

        // return true; // Indicate successful login
      } catch (error) {
        console.error("Login failed:", error);
        if (this.type == "cancel") {
          this.failurePopup();
        } else {
          this.failurePopup("Login");
        }
        // return false; // Indicate failed login
      }
    },
    async loginToTeams() {
      const tenantId = process.env.VUE_APP_TENANT_ID;
      const clientId = process.env.VUE_APP_CLIENT_ID;
      try {
        let msalConfig;
        const msalInstanceData = sessionStorage.getItem("msalInstance");
        if (msalInstanceData) {
          msalConfig = JSON.parse(msalInstanceData);
          this.msalInstance = new window.msal.PublicClientApplication(
            msalConfig
          );
        } else {
          msalConfig = {
            auth: {
              clientId: clientId,
              authority: `https://login.microsoftonline.com/${tenantId}`,
              redirectUri: process.env.VUE_APP_TEAMS_REDIRECT_URI,
            },
          };
          this.msalInstance = new window.msal.PublicClientApplication(
            msalConfig
          );
          sessionStorage.setItem("msalInstance", JSON.stringify(msalConfig));
        }
        await this.showMicrosoftLogin();
      } catch (error) {
        console.error("Login failed:", error);
        if (this.type == "cancel") {
          this.failurePopup();
        } else {
          this.failurePopup("Login");
        }
      }
    },
    async loadGapiScript() {
      this.meetStatus = true;
      const script = document.createElement("script");
      script.src = "https://apis.google.com/js/api.js";
      script.onload = async () => {
        await this.initGapiClient();
      };
      document.head.appendChild(script);
    },
    async createTeamsmeeting() {
      let token;
      let emails;
      if (this.login_type == 1) {
        let payload = {
          company: this.roleValues.email.endsWith("@hire3x.com")
            ? "hire3x"
            : this.roleValues.email.endsWith("@simplify3x.com")
            ? "simplify"
            : this.roleValues.email.endsWith("@norwintechnologies.com")
            ? "norwintechnologies"
            : null,
        };
        const response = await getTeamsToken(payload);
        token = response.data.token;
        emails = this.roleValues.email;
      } else {
        if (!localStorage.getItem("teamsAccessToken")) {
          await this.loginToTeams();
        }
        token = localStorage.getItem("teamsAccessToken");
        emails = JSON.parse(sessionStorage.getItem("account")).idTokenClaims
          .email;
      }
      return axios({
        method: "post",
        url: `https://graph.microsoft.com/v1.0/users/${emails}/events`,
        data: JSON.stringify({
          subject: `Simplify3x Interview - ${this.particularJob.title} - ${this.candidate.name} - ${this.ScheduleInterview.startTime}`,
          start: {
            dateTime: this.newDataeVAS,
            timeZone: "UTC",
          },
          end: {
            dateTime: this.newDataeEnd,
            timeZone: "UTC",
          },
          isReminderOn: false,
          body: {
            contentType: "html",
            content: `<html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8">\r\n<meta name="Generator" content="Microsoft Exchange Server">\r\n<!-- converted from text -->\r\n<style><!-- .EmailQuote { margin-left: 1pt; padding-left: 4pt; border-left: #800000 2px solid; } --></style></head>\r\n<body>\r\n<font size="2"><span style="font-size:11pt;"><div class="PlainText">&nbsp;</div> <div class="PlainText"><h1> Please Join Scheduled Meeting </h1> <h3> Date: ${this.ScheduleInterview.selDate},  Start time: ${this.ScheduleInterview.startTime}</h3></div></span></font>\r\n</body>\r\n</html>\r\n`,
          },
          attendees: this.getAttendees(),
          isOnlineMeeting: true,
          onlineMeetingProvider: "teamsForBusiness",
          hideAttendees: this.hideAttendees(),
        }),
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          this.ScheduleInterview.meetingLink =
            response.data.onlineMeeting.joinUrl;
          this.ScheduleInterview.meetingID = response.data.id;
          // this.showSpinner = false;
          return response.status;
        })
        .catch((error) => {
          // this.showSpinner = false;
          this.failurePopup("Create meeting failed, try again!");
          this.LoaderStatus = false;
          throw error;
        });
    },
    getDateInFormat() {
      let val =
        this.ScheduleInterview.selDate.split("-")[2] +
        "-" +
        this.ScheduleInterview.selDate.split("-")[1] +
        "-" +
        this.ScheduleInterview.selDate.split("-")[0];
      return val;
    },
    async scheduleInterview() {
      const candidate = {
        name: this.candidate.name,
        email: this.candidate.email,
        phoneNumber: this.candidate.phoneNumber,
        candidateID: this.candidate.candidateID,
      };
      this.ScheduleInterview.candidate = candidate;
      if (this.vendor) {
        this.ScheduleInterview.vendorID = this.$route.params.vendorID;
      }
      // if (this.ScheduleInterview.panelist.length == 0) {
      //   delete this.ScheduleInterview.panelist;
      //   this.ScheduleInterview.requiredPanel = false;
      // }
      if (this.$route.name == "VendorKanban") {
        this.ScheduleInterview.teams = false;
        delete this.ScheduleInterview.selectedOption;
      }
      // this.ScheduleInterview.startTime = this.getFormattedTime(this.ScheduleInterview.startTime);
      // this.ScheduleInterview.endTime = this.getFormattedTime(this.ScheduleInterview.endTime);
      this.ScheduleInterview.date = this.getDateInFormat();
      if (this.vendor) {
        delete this.ScheduleInterview.selectedOption;
        delete this.ScheduleInterview.allowBot;
      }
      if (this.toRound == "F") this.ScheduleInterview.roundlevel = this.toRound;
      else if (this.toRound != null && this.toRound != "0") {
        this.ScheduleInterview["recruiterRemarks"] = this.remarks;
        this.ScheduleInterview.roundlevel = parseInt(this.toRound);
      }
      this.ScheduleInterview["recruiterRemarks"] = !this.ScheduleInterview[
        "recruiterRemarks"
      ]
        ? ""
        : this.ScheduleInterview["recruiterRemarks"];
      if (!this.ScheduleInterview.roundlevel)
        this.ScheduleInterview.roundlevel = 0;
      let scheduledData = JSON.parse(JSON.stringify(this.ScheduleInterview));
      if (scheduledData.externalPanelist.length == 0) {
        delete scheduledData.externalPanelist;
      }
      if (this.showbotinterviewContent) {
        scheduledData.externalPanelist = ["bot@hire3x.com"];
        scheduledData.interviewScheduleType = 3;
      }
      try {
        const response = await addScheduleInterview(scheduledData);

        if (response.status == 200) {
          this.closeScheduleInterview();
          this.$emit("schedule-success");
          this.$nextTick(() => {
            const value =
              this.ScheduleInterview.schedulename == "Schedule Interview"
                ? "scheduled"
                : "re-scheduled";
            var text = `Interview has been ${value}  to candidate "${this.candidate.name}"`;

            this.dynamicToast(value, `Successfully ${value}`, text);
          });
        } else {
          this.failurePopup("Something went wrong!");
        }
        this.panelError = false;
      } catch (error) {
        this.panelError = false;
        this.failurePopup("Something went wrong!");
        throw new Error(`Failed! Updating Interview:${error.status}`);
      }
    },
    copyToClipboard() {
      try {
        if (this.ScheduleInterview.meetingLink !== "") {
          navigator.clipboard.writeText(this.ScheduleInterview.meetingLink);

          this.toolTipTitle = "Copied";
        }
      } catch (error) {
        console.error("Error copying to clipboard:", error);
      }
    },
    removeIntPanel(id) {
      this.ScheduleInterview.panelist = this.ScheduleInterview.panelist.filter(
        (obj) => obj.panelID != id
      );
    },
    selInternalPanelist(data) {
      this.addPanel(data);
    },
    handleEnter() {
      if (this.extEmail && this.isValidEmail) {
        this.ScheduleInterview.externalPanelist.push(this.extEmail);
        this.extEmail = "";
      }
    },
    closeScheduleInterview() {
      this.$emit("close-schedule");
    },
    removeExtPanel(index) {
      this.ScheduleInterview.externalPanelist.splice(index, 1);
    },
    async getScheduledDetails() {
      const response = await getScheduledInterview(
        this.candidate.kanbanInterviewID
      );
      if (response.status == 200) {
        this.interviewRound = response.data.data;
        // this.ScheduleInterview = response.data.data;
        this.ScheduleInterview.allowBot = response.data.data.interviewRound.bot;
        this.ScheduleInterview.selDate = response.data.data.date.split("T")[0];
        this.ScheduleInterview.selDate = this.getDateInFormat();
        this.initialStartTime = this.getFormattedTime(
          response.data.data.startTime
        );
        this.ScheduleInterview.startTime = this.getFormattedTime(
          response.data.data.startTime
        );
        this.ScheduleInterview.endTime = this.getFormattedTime(
          response.data.data.endTime
        );
        this.ScheduleInterview.meetingLink = response.data.data.meetingLink;
        this.initialLink = response.data.data.meetingLink;
        this.ScheduleInterview.meetingSummary =
          response.data.data.meetingSummary;
        this.ScheduleInterview.externalPanelist =
          response.data.data.externalPanelist;
        this.ScheduleInterview.candidate = response.data.data.candidate;
        this.ScheduleInterview.panelist = response.data.data.panelist;
        if (this.ScheduleInterview.panelist.length) {
          this.ScheduleInterview.panelist.map((obj) => {
            this.totalPanel.push({ name: obj.name, panelID: obj.panelID });
          });
        }
        if (
          this.ScheduleInterview.externalPanelist.length &&
          response.data.data.interviewRound.interviewScheduleType != 3
        ) {
          this.ScheduleInterview.externalPanelist.map((obj) => {
            this.totalPanel.push({ name: obj });
          });
        }
        if (response.data.data.interviewRound.interviewScheduleType == 3)
          this.ScheduleInterview.externalPanelist = [];
        if (!this.vendor) {
          if (
            response.data.data.interviewRound.roomId &&
            response.data.data.interviewRound.interviewScheduleType == 3 &&
            this.checkVCCLAccess &&
            this.showBot
          ) {
            this.showbotinterviewContent = true;
          } else this.showinternalexternalContent = true;
          if (
            response.data.data.interviewRound.meetingID &&
            this.checkTeamsAccess
          ) {
            this.ScheduleInterview.selectedOption = "Microsoft Teams";
          } else if (
            response.data.data.interviewRound.roomId &&
            this.checkVCCLAccess
          ) {
            this.ScheduleInterview.selectedOption = "Hire3x - VCCL";
          } else if (response.data.data.interviewRound.meetingCode) {
            this.ScheduleInterview.selectedOption = "Google Meet";
          } else {
            this.ScheduleInterview.selectedOption = "Other";
          }
        } else {
          this.ScheduleInterview.selectedOption = "Other";
        }
        this.initialType = this.ScheduleInterview.selectedOption;
        this.LoaderStatus = false;
      } else {
        this.errorModal("Something went wrong!");
      }
    },
    async setCandidateData() {
      if (this.candidate.kanbanScheduled) {
        await this.getScheduledDetails();
      } else if (this.candidate.recSlot) await this.getSelectedPanelSlot();
      // this.$nextTick(() =>{
      this.ScheduleInterview.roundlevel = this.candidate.kanbanLevel;
      this.ScheduleInterview.schedulename =
        this.candidate.kanbanScheduled || this.candidate.recSlot
          ? "Reschedule Interview"
          : "Schedule Interview";
      // })
      this.schedulename = this.ScheduleInterview.schedulename;
    },
    getPanelistCount() {
      return (
        this.ScheduleInterview.panelist.length +
        this.ScheduleInterview.externalPanelist.length
      );
    },
    emailChange(event) {
      const input = event.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      this.extEmail = input.value.toLowerCase();
      this.$nextTick(() => {
        input.setSelectionRange(start, end);
      });
      if (input.length == 0) this.showsearchDropdown = false;
    },
  },
};
export default scheduleMixin;
